import React from "react";
import { FileX } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { ExceptionsTable } from "./ExceptionsTable";
import { RuleException } from "../types";

interface ExceptionTableContainerProps {
  ruleExceptions: RuleException[];
  loading: boolean;
  onSelectRuleException: (ruleExceptionId: number) => void;
  onUpdateStatus: (ruleExceptionId: number, status: string) => Promise<boolean>;
}

export const ExceptionTableContainer: React.FC<ExceptionTableContainerProps> = ({
  ruleExceptions,
  loading,
  onSelectRuleException,
  onUpdateStatus,
}) => {
  return (
    <Card className="border-0 shadow-sm bg-white">
      <CardContent className="p-0">
        {ruleExceptions.length === 0 && !loading ? (
          <div className="p-12 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-100 rounded-full mb-4">
              <FileX className="h-8 w-8 text-slate-400" />
            </div>
            <h3 className="text-lg font-medium text-slate-800 mb-2">No Rule Exceptions</h3>
            <p className="text-slate-600 max-w-sm mx-auto">
              No rule exceptions found for the current reporting period with the applied filters.
            </p>
          </div>
        ) : (
          <ExceptionsTable
            ruleExceptions={ruleExceptions}
            onSelectRuleException={onSelectRuleException}
            onUpdateStatus={onUpdateStatus}
          />
        )}
      </CardContent>
    </Card>
  );
}; 